import React, { Fragment } from "react";

const HtmlAsText = ({ htmlContent }) => {
  const htmlToPlainText = (html) => {
    // Create a new div element
    const div = document.createElement("span");
    // Set the HTML content with the provided html string
    div.innerHTML = html;
    // Use innerText to get the plain text content, which automatically decodes HTML entities
    return div.innerText.replace(/\u00A0/g, " "); // Replace non-breaking spaces with regular spaces
  };

  const plainText = htmlToPlainText(htmlContent);

  return <Fragment>{plainText}</Fragment>;
};

export default HtmlAsText;
